export default __webpack_public_path__ + "187aa4c1ceded5ddeab457ba26c1eb65.svg";